import { Type } from '../helpers.js'

export default function LogicCommands(context) {
    let { evaluate } = context;

    function Not (x) { return  !x; }
    function Test(x) { return !!x; }

    function _And(item, ...rest) {
        let x = evaluate(item);
        return (rest.length < 1) ? x : x && _And(...rest);
    }

    function _Or(item, ...rest) {
        let x = evaluate(item);
        return (rest.length < 1) ? x : x || _Or(...rest);
    }

    function XOr(item, ...rest) {
        let it = !!item;
        return it !== (rest.length > 0 && XOr(...rest));
    }

    let _same = (a, b) => (a === b) || (Type(a) === 'null' && Type(b) === 'null');

    function EQ(a, b, ...rest) {
        let t = Type(a);
        if (t !== Type(b)) { return false; }
        let keys = (a, b) => Object.keys(a).concat(Object.keys(b));
        let res  = (t === 'array' ) ? a.length === b.length && a.reduce((e, ai, i) => e && EQ(ai, b[i]), true) :
                   (t === 'object') ? keys(a, b).reduce((e, k) => e && EQ(a[k], b[k]), true)
                                    : _same(a, b);
        return res && (rest.length < 1 || EQ(b, ...rest));
    }

    function Is(a, b, ...rest) {
        return _same(a, b) && (rest.length < 1 || Is(b, ...rest));
    }

    function NE   (a, b, ...rest) { return !EQ(a, b, ...rest); }
    function IsNot(a, b, ...rest) { return !Is(a, b, ...rest); }
    function LT   (a, b, ...rest) { return (a <  b) && (rest.length < 1 || LT (b, ...rest)); }
    function GT   (a, b, ...rest) { return (a >  b) && (rest.length < 1 || GT (b, ...rest)); }
    function LTE  (a, b, ...rest) { return (a <= b) && (rest.length < 1 || LTE(b, ...rest)); }
    function GTE  (a, b, ...rest) { return (a >= b) && (rest.length < 1 || GTE(b, ...rest)); }

    return {
        Not, Test, _And, _Or, XOr, EQ, NE, LT, GT, LTE, GTE, Is, IsNot,
        ['=']: EQ, ['!=']: NE, ['<']: LT, ['>']: GT, ['<=']: LTE, ['>=']: GTE
    };
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/command-action-handler/src/commands/logic.js